import { ReactNode, useMemo, useRef, useState } from 'react';
import { AsyncTypeAheadFieldInstance } from 'components/forms/typeAheadField/AsyncTypeAheadField.types';
import useLocalStorage from 'hooks/useLocalStorage';
import PropertiesContext from './PropertiesContext';
import {
  PropertiesFilterSchema,
  PropertiesFilterSchemaType,
} from './filters/PropertiesFilter.schema';

const PropertiesContextProvider = ({
  children,
  localStorageKey,
}: {
  children: ReactNode;
  localStorageKey: string;
}) => {
  const propertySearchFieldRef = useRef<AsyncTypeAheadFieldInstance>();

  const { getValue: getStoredFormValues } =
    useLocalStorage<PropertiesFilterSchemaType>(localStorageKey);
  const storedFormValues = getStoredFormValues();
  const [lastSubmittedFilters, setLastSubmittedFilters] = useState(
    storedFormValues
      ? (PropertiesFilterSchema.cast(
          storedFormValues,
        ) as PropertiesFilterSchemaType)
      : null,
  );

  const contextValue = useMemo(
    () => ({
      lastSubmittedFilters,
      propertiesFilterLocalStorageKey: localStorageKey,
      propertySearchFieldRef,
      setLastSubmittedFilters,
    }),
    [
      lastSubmittedFilters,
      localStorageKey,
      propertySearchFieldRef,
      setLastSubmittedFilters,
    ],
  );

  return (
    // @ts-expect-error TS2322 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
    <PropertiesContext.Provider value={contextValue}>
      {children}
    </PropertiesContext.Provider>
  );
};

export default PropertiesContextProvider;
